import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useOrganization } from "../configurations/OrganizationContext";
import {
  VEDAMAAYU_HOSPITAL_ADDRESS,
  VEDAMAAYU_HOSPITAL_DESC,
  VEDAMAAYU_HOSPITAL_NAME,
} from "../shared/constants";
import htmlToPdfmake from "html-to-pdfmake";

const rich = (html) => {
  if (!html || typeof html !== "string") return [{ text: "" }];
  const cleaned = html.replace(/<p><br\s*\/?><\/p>/gi, "");
  if (!cleaned.trim()) return [{ text: "" }];
  const result = htmlToPdfmake(cleaned, {
    defaultStyles: {
      b: { bold: true },
      strong: { bold: true },
      i: { italics: true },
      em: { italics: true },
      u: { decoration: "underline" },
      s: { decoration: "lineThrough" },
      p: { margin: [0, 0, 0, 2] },
    },
  });
  return Array.isArray(result) ? result : [result];
};

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const qz = require("qz-tray");

function VedamaayuDischargePrint(props) {
  const org = useOrganization();
  const printerName = process.env.REACT_APP_PRINTER_NAME;

  // ── Patient info ──────────────────────────────────────────────────────────
  var id = props.patientdetails.resCb.id ? props.patientdetails.resCb.id : "";
  var patient_name =
    props.patientdetails.resCb.fname ||
    props.patientdetails.resCb.mname ||
    props.patientdetails.resCb.lname
      ? props.patientdetails.resCb.fname +
        " " +
        props.patientdetails.resCb.mname +
        " " +
        props.patientdetails.resCb.lname
      : "";

  var IP_number = props?.patientdetails?.resCb?.visit?.ipopnumber
    ? props?.patientdetails?.resCb?.visit?.ipopnumber
    : "";

  var Age = props.patientdetails.resCb.age ? props.patientdetails.resCb.age : "";
  var gender = props.patientdetails.resCb.gender ? props.patientdetails.resCb.gender : "";

  var DATE_of_discharge = "";
  if (props.summary.dischargedt) {
    const date = new Date(props.summary.dischargedt);
    DATE_of_discharge = new Intl.DateTimeFormat("en-US", {
      weekday: "short", month: "short", day: "numeric",
      year: "numeric", hour: "numeric", minute: "numeric",
    }).format(date);
  } else {
    DATE_of_discharge = new Intl.DateTimeFormat("en-US", {
      weekday: "short", month: "short", day: "numeric",
      year: "numeric", hour: "numeric", minute: "numeric",
    }).format(new Date());
  }

  // ── DOA ───────────────────────────────────────────────────────────────────
  const inputDate = new Date(props?.patientdetails?.resCb?.visit?.admsnDate);
  var Date_of_admission = inputDate.toLocaleString("en-US", {
    weekday: "short", year: "numeric", month: "short",
    day: "numeric", hour: "numeric", minute: "numeric",
  });

  // ── Address / phone ───────────────────────────────────────────────────────
  const city = props.patientdetails.resCb.city;
  const state = props.patientdetails.resCb.state;
  const pincode = props.patientdetails.resCb.pincode;
  var Address =
    (props.patientdetails.resCb.address
      ? props.patientdetails.resCb.address + ", "
      : "") +
    (city ? city : "Arkula") +
    (state ? ", " + state : ", Karnataka") +
    (pincode ? " " + pincode : "");

  var PHONE_NO = props.patientdetails.resCb.phno ? props.patientdetails.resCb.phno : "";

  // ── Ward / Room ───────────────────────────────────────────────────────────
  const roomList = props?.patientdetails?.resCb?.roomList || [];
  const Room_number = roomList
    .map((room) =>
      room.floorId ? `Floor ${room.floorId} - ${room.roomName}` : room.roomName
    )
    .join(", ");

  // ── Follow up ─────────────────────────────────────────────────────────────
  var folloUp = "";
  if (props.revisitDetails) {
    folloUp = new Date(props.revisitDetails).toLocaleDateString("en-GB");
  } else {
    folloUp = "Weekly";
  }

  // ── Emergency contact ─────────────────────────────────────────────────────
  const contctNumber = "+91 " + process.env.REACT_APP_EMERGENCY_NUNBER;

  // ── Medicine table ────────────────────────────────────────────────────────
  const medicines = props.summary["Advice on discharge"] || [];
  const medicineTable =
    medicines.length > 0
      ? {
          table: {
            widths: ["*", "*", "*", "*"],
            margin: [0, 0, 0, 0],
            body: medicines.map((m, index) => {
              const isLast = index === medicines.length - 1;
              return [
                { text: m.medicine || "", border: [false, false, true, !isLast] },
                { text: m.dose || "", border: [false, false, true, !isLast] },
                { text: m.frequency || "", border: [false, false, true, !isLast] },
                { text: m.comment || "", border: [false, false, false, !isLast] },
              ];
            }),
          },
        }
      : { text: "" };

  useEffect(() => {
    props.parentCallBack();
    dischargeSummaryPrint();
  }, []);

  const extractData = () => {
    return {
      pageMargins: [40, 144, 40, 55],
      content: [
        // ── Title ──────────────────────────────────────────────────────────
        {
          text: "DISCHARGE SUMMARY",
          style: "pageTitle",
          alignment: "center",
          margin: [0, 0, 0, 3],
        },

        // ── TABLE 1: Patient Info ──────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [170, 100, 120, 100],
            body: [
              [
                { text: "PATIENT NAME", style: "center", fillColor: "lightgray" },
                { colSpan: 3, text: patient_name },
                "", "",
              ],
              [
                { text: "UHID", style: "center", fillColor: "lightgray" },
                id,
                { text: "DATE OF ADMISSION (DOA)", fillColor: "lightgray" },
                Date_of_admission,
              ],
              [
                { text: "AGE / GENDER", fillColor: "lightgray" },
                `${Age} / ${gender}`,
                { text: "DATE OF DISCHARGE (DOD)", fillColor: "lightgray" },
                DATE_of_discharge,
              ],
              [
                { text: "IP NUMBER", style: "center", fillColor: "lightgray" },
                IP_number,
                { text: "WARD", fillColor: "lightgray" },
                Room_number,
              ],
              [
                { text: "ADDRESS", style: "center", fillColor: "lightgray" },
                Address,
                { text: "PHONE NO.", fillColor: "lightgray" },
                PHONE_NO,
              ],
              [
                {
                  text: "TREATING DOCTORS",
                  style: "center",
                  fillColor: "lightgray",
                },
                {
                  colSpan: 3,
                  text: props.doctorList?.join(", ") || "",
                },
                "", "",
              ],
              [
                {
                  text: "DIAGNOSIS WITH ICD-10/11 CODE",
                  style: "center",
                  fillColor: "lightgray",
                },
                {
                  colSpan: 3,
                  stack: rich(props.summary["Final Diagnosis"]),
                },
                "", "",
              ],
            ],
          },
        },

        // ── Chief Complaints / History of Present Illness ──────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [170, 338],
            body: [
              [
                { text: "CHIEF COMPLAINTS", fillColor: "lightgray" },
                { text: "HISTORY OF PRESENT ILLNESS", alignment: "center", fillColor: "lightgray" },
              ],
              [
                { stack: rich(props.summary["Chief Complaints"]) },
                { stack: rich(props.summary["Clinical Summary"]) },
              ],
            ],
          },
        },

        // ── Clinical fields ────────────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [170, 338],
            body: [
              [
                { text: "GENERAL PHYSICAL EXAMINATION INCLUDING VITALS", fillColor: "lightgray" },
                { stack: rich(props.summary["General physical examination"]) },
              ],
              [
                { text: "SYSTEMIC EXAMINATION", fillColor: "lightgray" },
                { stack: rich(props.summary["Systemic Examination"]) },
              ],
              [
                { text: "INVESTIGATION DONE", fillColor: "lightgray" },
                { stack: rich(props.summary["Clinical Investigations"]) },
              ],
            ],
          },
        },

        // ── Course of treatment ────────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [516],
            body: [
              [
                {
                  text: "COURSES OF TREATMENT IN THE HOSPITAL",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [{ stack: rich(props.summary["Course of treatment in hospital"]) }],
            ],
          },
        },

        // ── Condition on Discharge ─────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [516],
            body: [
              [
                {
                  text: "CONDITION ON DISCHARGE",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [{ stack: rich(props.summary["Condition on Discharge"]) }],
            ],
          },
        },

        // ── Treatment Advised (medicine table) ────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [516],
            body: [
              [
                {
                  text: "TREATMENT ADVISED\nRx \t (MEDICINES)",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [
                {
                  stack: [medicineTable],
                  margin: [0, 0, 0, 0],
                  border: [true, true, true, true],
                },
              ],
            ],
          },
        },

        // ── Follow Up ─────────────────────────────────────────────────────
        {
          text: [{ text: "FOLLOW UP DATE: ", bold: true }, { text: folloUp }],
          style: "fontsize",
          margin: [0, 8, 0, 0],
        },
        { text: "\n", style: "fontsize" },

        // ── Review in case of ─────────────────────────────────────────────
        {
          style: "fontsize",
          margin: [0, 0, 0, 10],
          table: {
            widths: [516],
            body: [
              [
                {
                  text: "REVIEW IN CASE OF",
                  alignment: "center",
                  fillColor: "lightgray",
                },
              ],
              [{ stack: rich(props.summary["Review in case of"]) }],
            ],
          },
        },

        // ── Note ──────────────────────────────────────────────────────────
        {
          columns: [
            { width: 30, text: "Note :", style: "fontsize", bold: true },
            {
              width: "*",
              text:
                "DON'T STOP MEDICINES ABRUPTLY.\n" +
                "TO CONTINUE TREATMENT TILL THE NEXT FOLLOW UP CONSULTATION.",
              style: "fontsize",
              bold: true,
            },
          ],
        },
        { text: "\n", style: "fontsize" },

        // ── Emergency contact ─────────────────────────────────────────────
        {
          text: [
            { text: "CONTACT IN CASE OF EMERGENCY: ", bold: true },
            { text: contctNumber },
          ],
          style: "fontsize",
        },
        { text: "\n", style: "fontsize" },

        {
          text: "I/We have understood the instructions given about the medication dosage and post discharge care\n\n\n",
          style: "fontsize",
        },

        // ── Signature Section ─────────────────────────────────────────────
        {
          margin: [20, 5, 0, 0],
          table: {
            widths: [25, "*"],
            body: [
              // 1 - Patient / Relative
              [
                { text: "1)", style: "fontsize" },
                {
                  stack: [
                    { text: "Signature :", style: "fontsize" },
                    { text: "Patient / Relative", style: "fontsize" },
                    { text: "Name :", style: "fontsize" },
                    { text: "Relationship :", style: "fontsize" },
                  ],
                  margin: [0, 0, 0, 12],
                },
              ],
              // 2 - Doctor's Signature
              [
                { text: "2)", style: "fontsize" },
                {
                  stack: [
                    {
                      text: "Consultant / Treating Doctor",
                      style: "fontsize",
                    },
                    {
                      stack: (props.doctorList || []).map((doctor) => ({
                        text: doctor,
                        style: "fontsize",
                        bold: true,
                        margin: [0, 0, 0, 4],
                      })),
                      margin: [0, 4, 0, 5],
                    },
                    { text: "Signature :", style: "fontsize" },
                  ],
                  margin: [0, 0, 0, 12],
                },
              ],
            ],
          },
          layout: "noBorders",
        },

        {
          text: "------------------------------------------------- x ------------------------------------------------- x -------------------------------------------------",
          margin: [0, 15, 0, 0],
        },
      ],

      footer: function (currentPage, pageCount) {
        return [
          {
            text: VEDAMAAYU_HOSPITAL_NAME,
            alignment: "left",
            fontSize: 6,
            color: "#176fad",
            bold: true,
            margin: [40, 10, 0, 0],
          },
          {
            text: VEDAMAAYU_HOSPITAL_DESC,
            alignment: "left",
            fontSize: 6,
            color: "#176fad",
            bold: true,
            margin: [40, 0, 0, 0],
          },
          {
            text: VEDAMAAYU_HOSPITAL_ADDRESS,
            alignment: "left",
            fontSize: 6,
            margin: [40, 0, 0, 10],
          },
        ];
      },

      styles: {
        fontsize: { fontSize: 10 },
        pageTitle: { fontSize: 13, bold: true, margin: [0, 10, 0, 5] },
      },
      defaultStyle: {},
    };
  };

  async function dischargeSummaryPrint() {

    const docDefinition = extractData();
    printPdf(docDefinition);
  }

  function printPdf(docDefinition) {
    pdfMake.createPdf(docDefinition).open();

    pdfMake.createPdf(docDefinition).getBase64((data) => {
      qz.websocket
        .connect()
        .then(() => qz.printers.find())
        .then((printers) => {
          const printer = printers.find((p) => p.includes(printerName));
          if (!printer) throw new Error("Printer not found");
          const config = qz.configs.create(printer, {
            size: { width: 148, height: 210 },
            units: "mm",
          });
          return qz.print(config, [
            { type: "pixel", format: "pdf", flavor: "base64", data },
          ]);
        })
        .then(() => qz.websocket.disconnect())
        .catch(console.error);
    });
  }

  return null;
}

export default VedamaayuDischargePrint;